import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import { CalendarPickerMonthView } from 'selectors/offerPage/offerPageSelectors'
import { pluralizeToString } from 'lib/string/pluralize'
import MobileMultipleRoomsDurationLabel from 'components/OfferPage/MultipleRoomsBooking/Mobile/MobileMultipleRoomsDurationLabel'

interface Props {
  duration: number
  month: CalendarPickerMonthView
  hasOtherAvailability: boolean
  enableCalendarRecommendations: boolean
  selected?: boolean
  soldOutText?: string
  hideChildPrices?: boolean
  markCheapestPrice?: boolean
  isMultiRoom?: boolean
}

function OfferCalendarHotelMonthTile(props: Props) {
  const {
    month,
    duration,
    hasOtherAvailability,
    enableCalendarRecommendations,
    selected,
    soldOutText = 'Sold out',
    hideChildPrices,
    markCheapestPrice,
    isMultiRoom,
  } = props

  const subTextColour = selected ? undefined : 'neutral-three'
  const priceDefaultColour = markCheapestPrice && month.cheapest ? 'highlight-secondary' : undefined
  const priceColour = month.isLuxPlusPrice && !selected ? 'lux-plus' : priceDefaultColour

  return (
    <div>
      {!month.hotelAvailable && <>
        <Caption variant="medium" colour={subTextColour}>{soldOutText}</Caption>
        {!hasOtherAvailability && enableCalendarRecommendations && <TextLink size="small" weight="regular">
          View similar offers
        </TextLink>}
        {hasOtherAvailability &&
          <TextLink size="small" weight="regular">
            Available in other room types
          </TextLink>}
      </>}
      {month.hotelAvailable && <>
        {hideChildPrices && <Caption variant="medium" colour="neutral-three" underline>{!selected ? 'Select check-in date' : 'View availability'}</Caption>}
        {!hideChildPrices && <div>
          {!isMultiRoom && <Caption variant="medium" colour={subTextColour}>{pluralizeToString('night', duration)} from</Caption>}
          {isMultiRoom && <Caption variant="medium" colour={subTextColour}><MobileMultipleRoomsDurationLabel shouldDisplayRoom shouldDisplayFlight={false} /></Caption>}
          <BodyText as="span" variant="medium" weight="bold" colour={priceColour}>
            <FormatCurrency value={month.hotelTotal} />
          </BodyText>{' '}
          <Caption as="span" variant="medium" colour={(month.isLuxPlusPrice && !selected) ? 'lux-plus' : subTextColour}>
            total
          </Caption>
        </div> }
      </> }
    </div>
  )
}

export default React.memo(OfferCalendarHotelMonthTile)
